import { RgDataSetID } from '../../data/rg-data-set-id.js';
import { RG_TYPE } from '../../types/rg-type.js';

const DefaultSite = {
    type: RG_TYPE.Site,
    data: {
        dataset: RgDataSetID.uk_01,
        coords: { latitude: 0, longitude: 0 },
        polygon: [[-10, 0, -10], [10, 0, -10], [5, 0, 5], [-10, 0, -10]]
    },
    children: []
};

export { DefaultSite };
//# sourceMappingURL=default-site.js.map
